import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ConfirmationModal = ({ 
  show, 
  handleClose, 
  handler, 
  message,
}) => (
  <Modal show={show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>Confirmation</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {message}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>
        Cancel
      </Button>
      <Button variant="success" onClick={handler}>
        Confirm
      </Button>
    </Modal.Footer>
  </Modal>
  );

  ConfirmationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handler: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
  };

export default ConfirmationModal;
